
import { SaveAddressButton } from "../../save-address/SaveAddressButton";
import { ClearAddressButton } from "../../clear-address/ClearAddressButton";
import { AddressActionsProps } from "@/types/address";

export const AddressActions = ({
  onClear,
  onSave,
  prefix,
}: AddressActionsProps) => {
  return (
    <div className="flex justify-between items-center mt-5">
      <ClearAddressButton onClear={onClear} />
      <SaveAddressButton
        onSave={onSave}
        prefix={prefix}
      />
    </div>
  );
};
